import { For } from 'solid-js';

export type SegmentedOption<T extends string> = {
  value: T;
  label: string;
};

export function SegmentedControl<T extends string>(props: {
  value: T;
  onChange: (value: T) => void;
  options: readonly SegmentedOption<T>[];
}) {
  return (
    <div class="segmented" role="group">
      <For each={props.options}>
        {opt => (
          <button
            type="button"
            class="segmented__btn"
            aria-pressed={props.value === opt.value}
            onClick={() => props.onChange(opt.value)}
          >
            {opt.label}
          </button>
        )}
      </For>
    </div>
  );
}
